import { EnhancedScopeData } from '@ardoq/data-model';
import { I18nLocale, t } from '@ardoq/i18n';
import { LabelAndValue } from '@ardoq/suggestions-api';
import React, { useMemo } from 'react';
import { IFilterParams } from 'ag-grid-enterprise';
import { APIComponentAttributes, ArdoqId } from '@ardoq/api-types';
import { toIds } from '@ardoq/core';
import { InventoryContext } from '../types';
import {
  getFilterOptionLabel,
  predefinedSelectOptions,
} from './agGridFilterOperations';
import { CustomComponentSelectionFilter } from './CustomComponentSelectionFilter';

type ReferenceFilterProps = IFilterParams<
  APIComponentAttributes,
  InventoryContext
>;

const getDefaultOptionsGroup = (i18nLocale: I18nLocale) => ({
  label: t(
    i18nLocale,
    'inventoryApp:ag.filter.defaultOptionsGroupLabel',
    'Default options'
  ),
  options: [
    {
      label: getFilterOptionLabel(
        predefinedSelectOptions.hasReferences,
        i18nLocale
      ),
      value: predefinedSelectOptions.hasReferences,
    },
    {
      label: getFilterOptionLabel(
        predefinedSelectOptions.noReferences,
        i18nLocale
      ),
      value: predefinedSelectOptions.noReferences,
    },
  ],
});

const isSpecialValue = (id: ArdoqId): boolean =>
  id === predefinedSelectOptions.noReferences ||
  id === predefinedSelectOptions.hasReferences;

const getResolveSpecialFilterValue =
  (i18nLocale: I18nLocale) =>
  (value: string): LabelAndValue => ({
    label: getFilterOptionLabel(value, i18nLocale),
    value: value,
  });

const getWorkspaceIds = (scopeData: EnhancedScopeData): ArdoqId[] =>
  toIds(scopeData.workspaces);

export const ReferencedComponentsFilter = (props: ReferenceFilterProps) => {
  // props.context.scopeData has the stale value from the initialization of the grid
  const scopeData = (props.api.getGridOption('context') as InventoryContext)
    .scopeData;
  const workspaceIds = useMemo(() => getWorkspaceIds(scopeData), [scopeData]);

  return (
    <CustomComponentSelectionFilter
      {...props}
      workspaceIdsScopeForSuggestions={workspaceIds}
      getDefaultOptionsGroup={getDefaultOptionsGroup}
      isSpecialValue={isSpecialValue}
      getResolveSpecialFilterValue={getResolveSpecialFilterValue}
    />
  );
};
